import { Flex } from '@coolblue-development/freddy';
import selectMoreLessFiltersTrigger from '@coolblue-development/ga4-events/triggers/FilterAndSort/selectMoreLessFiltersTrigger';
import type { ReactNode } from 'react';
import { Children } from 'react';

import Collapse from './Collapse';

type Props = {
  children: ReactNode;
  displayName: string;
};

const CollapsibleContainer = ({ children, displayName }: Props) => {
  const childrenArray = Children.toArray(children);
  const pinnedChildren = [];
  const collapsedChildren = [];

  if (childrenArray.length > 6) {
    pinnedChildren.push(...childrenArray.slice(0, 5));
    collapsedChildren.push(...childrenArray.slice(5));
  } else {
    pinnedChildren.push(...childrenArray);
  }

  if (pinnedChildren.length === 0) {
    return <></>;
  }

  const trackingParams = {
    property_name: displayName,
    sub_feature: 'filter_list'
  } as const;

  const trackingExpandedTrigger = selectMoreLessFiltersTrigger({
    ...trackingParams,
    method: 'expand'
  });

  const trackingCollapsedTrigger = selectMoreLessFiltersTrigger({
    ...trackingParams,
    method: 'collapse'
  });

  return (
    <>
      <List>{pinnedChildren}</List>

      {collapsedChildren.length > 0 && (
        <Collapse
          trackingExpandedTrigger={trackingExpandedTrigger}
          trackingCollapsedTrigger={trackingCollapsedTrigger}
          collapsedLength={collapsedChildren.length}
        >
          <List>{collapsedChildren}</List>
        </Collapse>
      )}
    </>
  );
};

const List = ({ children }: { children: ReactNode }) => (
  <Flex direction='column' component='ul' my={0} pl={0} gap={100} sx={{ listStyle: 'none' }}>
    {children}
  </Flex>
);

export default CollapsibleContainer;
